// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.78-TSS-3086-mcastro-MEMBERS-WITH-GUEST-PERMISSIONS-Moving-to-Shared-With-Me.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
